export const notNull = <T>(value: T | null): value is T => value !== null;

export const convertAcuuPrecImageUrlResolution = (url: string): string => {
  if (url.indexOf("HIGHREZ") !== -1)
    return url.replace(/(highrez.png)/gi, "LOWREZ.png");

  if (url.indexOf("highrez") !== -1)
    return url.replace(/(highrez.png)/gi, "lowrez.png");

  if (url.indexOf("LOWREZ") !== -1)
    return url.replace(/(lowrez.png)/gi, "HIGHREZ.png");

  if (url.indexOf("lowrez") !== -1)
    return url.replace(/(lowrez.png)/gi, "highrez.png");

  return url;
};
